/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Advantage_QuotasInputs */

const en_why_listening_advantage_quotas = /** @type {(inputs: Why_Listening_Advantage_QuotasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No word or hour quotas`)
};

const es_why_listening_advantage_quotas = /** @type {(inputs: Why_Listening_Advantage_QuotasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin límites de palabras ni de horas`)
};

/**
* | output |
* | --- |
* | "No word or hour quotas" |
*
* @param {Why_Listening_Advantage_QuotasInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_advantage_quotas = /** @type {((inputs?: Why_Listening_Advantage_QuotasInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Advantage_QuotasInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_advantage_quotas(inputs)
	return en_why_listening_advantage_quotas(inputs)
});